import { render } from "./MainSection.vue?vue&type=template&id=2cc32ab1"
import script from "./MainSection.vue?vue&type=script&lang=js"
export * from "./MainSection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__